import { NavLink } from "react-bootstrap";
import "./footer.css";

const Footer = () => {
  return (
    <>
      <footer className="footer pt-5 text-white">
        <div className="container">
          <div className="row g-4">
            {/* Company Info */}
            <div className="col-md-4 order-1 order-sm-1 order-md-1">
              <div className="position-relative heading-container mx-auto ">
                <h2 className="heading" id="footer-heading">
                  B<span className="heading-span">EST</span> D
                  <span className="heading-span">EAL</span> E
                  <span className="heading-span">LECTRICALS</span>{" "}
                </h2>
                <div className="line" id="line"></div>
              </div>
              <p>
                Best Deal Electricals is a leading OEM for LT Panels,
                Stabilizers, UPS, and custom electrical solutions. Proudly Made
                in India, our products power industries, data centers, and
                commercial projects. We combine precision engineering,
                durability, and safety in every solution we deliver. Backed by
                expert teams and modern manufacturing, we ensure quality you can
                trust.{" "}
              </p>
            </div>

            {/* Quick Links */}
            <div className="col-md-4 col-sm-6 d-flex quick-links order-sm-2 order-md-2 order-3">
              <div className="">
                <h5 className="fw-bold mb-3">Quick Links</h5>
                <ul className="list-unstyled">
                  <li>
                    <NavLink href="/" className="nav-elements ">
                      Home
                    </NavLink>
                  </li>
                <li>
                    <NavLink href="/abouts" className="nav-elements">
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink href="/products" className="nav-elements">
                      Products
                    </NavLink>
                  </li>
                  <li>
                    <NavLink href="/clients" className="nav-elements">
                      Clients
                    </NavLink>
                  </li>
                    <li>
                     <NavLink href="/certificates" className="nav-elements ">Certificates</NavLink>
                    </li>
                  <li>
                    <NavLink href="/contact" className="nav-elements">
                      Contact
                    </NavLink>
                  </li>
                       <li>
                    {" "}
                    <a
                      href="/Company Profile BDE.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <div className="nav-elements">Profile</div>
                    </a>
                  </li>
                  <li>
                    {" "}
                    <a
                      href="/BROCHURE.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      <div className="nav-elements">Brochure</div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="col-md-4 col-sm-6 order-sm-1 order-md-3 order-2">
              <h5 className="fw-bold mb-3">Get In Touch</h5>

              <p>
                <strong>Address:</strong>
                <br />
                Plot No - 256, Phase 9, Industrial Area, Mohali, Punjab
              </p>

              <p>
                <strong>Phone:</strong>
                <br />
                +91 9779096815
                <br />
                +91 9779490815
                <br />
                +91 9779188815
              </p>

              <p>
                <strong>Emails:</strong>
                <br />
                admin@mamtabestdealelectricals.com
                <br />
                bestdealelectricals4444@gmail.com
              </p>
            </div>
          </div>
        </div>

      <section className="license py-4">
  &copy; 2025 <strong>Best Deal Electricals</strong>. All rights reserved. ||
   <a href="https://sparrowind.in" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-light"> Developed by <strong>Sparrowind </strong></a> ||
</section>
      </footer>
    </>
  );
};

export default Footer;
